import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants, TableConstants } from "utils/constants";
import { InvoiceFormTypes } from "models/formTypes";
import { CustomerGenericProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { ViewPanel } from "components/common";
import { InvoiceListView } from "components/invoice";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CustomerLatestInvoiceList: React.FC<CustomerGenericProps> = (props) => {
  const filter: InvoiceFormTypes.Filter = React.useMemo(
    () => ({ customers: [{ id: props.customerId, value: "" }] }),
    [props.customerId]
  );

  return (
    <>
      {props.customerId && (
        <ViewPanel
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.LatestInvoices)}
          icon={IconDefinitionConstants.WSend}
        >
          <InvoiceListView tableKey={TableConstants.LatestInvoiceList} filter={filter} includeSummary={false} />
        </ViewPanel>
      )}
    </>
  );
};
export default CustomerLatestInvoiceList;
